import * as yup from 'yup';

export default yup.object().shape({
  reasonField: yup.string().required('Campo obrigatório'),
});
